import { Component, h, Prop, State } from '@stencil/core';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import _ from 'lodash'
import '../header-component/header-component';
import '../loader-component/loader-component'
import $ from "jquery";

/** 
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/carousel-component.PNG)

#### Content Type
nypwebc_ct_picture
  
*/

@Component({
  tag: 'meettheteam-component',
  styleUrl: 'meettheteam-component.css',
  // shadow: true,
  scoped: true
})
export class MeettheteamComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
*Optional - To show/hide header. default is true
*/
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
*Optional -number of items per slide 
*/
  @Prop() itemsperslide: number = 4

  /**
*Optional -image border radius 
*/
  @Prop() imageradius: string = '10%'
  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;
  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";


  @Prop() filters: boolean = false;

  @State() items: [];
  @State() origItems: [];
  @State() isLoading: boolean = true;
  @State() modalShow: boolean = false;

  @State() modelBody
  @State() modelTitle
  @State() modelImageUrl

  @State() modelGroup
  @State() modelRole
  @State() modelInitiative
  @State() modelOrganization

  @State() role: string[] = []
  @State() group: string[] = []
  @State() initiative: string[] = []

  @State() roles: string[] = []
  @State() groups: string[] = []
  @State() initiatives: string[] = []
  @State() resultCount: number = 0

  handleClose = () => {
    this.modalShow = false

  }

  handleShow = (event, body, title, image, role, group, initiative, organization) => {

    console.log(body, title, image, event)

    let bodystring: string = ""
    let domNode: any;
    let bodyexist: boolean = false

    if (body != null) {
      bodystring = body;
      bodyexist = true;
      let parser = new DOMParser();
      domNode = parser.parseFromString(bodystring, "text/html");
      const img = domNode.querySelectorAll("img");
      const tables = domNode.querySelectorAll("table");

      for (let i = 0; i < img.length; i++) {
        img[i].classList.add("sc-carousel-multi-component", "img-fluid", "rounded");
      }
    }



    this.modalShow = true
    if (bodyexist) {
      this.modelBody = domNode.body.innerHTML
    }
    else {
      this.modelBody = ""
    }
    this.modelTitle = title
    this.modelImageUrl = image
    this.modelRole = role
    this.modelGroup = group
    this.modelInitiative = initiative
    this.modelOrganization = organization

  }


  componentDidLoad() {

    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    // const filter = "nypwebc_Active eq 1";


    // return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,img_group,img_initiative,img_role,FileLeafRef,img_body,img_readmore&$filter=" + filter + "&$orderby=nypwebc_ItemOrder", { headers: { "Accept": "application/json; odata=verbose" } })
    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,img_group,img_initiative,img_organization,img_role,FileLeafRef,img_body,img_readmore&$top=1000&$orderby=Modified desc", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.origItems = data.d.results;
        this.resultCount = data.d.results.length
        this.isLoading = false;
      });
  }
  handleChangeRole(event) {
    console.log(event.target.value)
    if (event.target.checked && event.target.value) {
      this.role.push(event.target.value)
    }
    else if (this.role.length > 0 && !event.target.checked) {
      let index = this.role.indexOf(event.target.value)
      if (index > -1) {
        this.role.splice(index, 1)
      }

    }
    this.getFilteredItems()
  }

  handleChangeGroup(event) {
    console.log(event.target.value)
    if (event.target.checked && event.target.value) {
      this.group.push(event.target.value)
    }
    else if (this.group.length > 0 && !event.target.checked) {
      let index = this.group.indexOf(event.target.value)
      if (index > -1) {
        this.group.splice(index, 1)
      }

    }
    this.getFilteredItems()
  }
  handleChangeInitiative(event) {
    console.log(event.target.value)
    if (event.target.checked && event.target.value) {
      this.initiative.push(event.target.value)
    }
    else if (this.initiative.length > 0 && !event.target.checked) {
      let index = this.initiative.indexOf(event.target.value)
      if (index > -1) {
        this.initiative.splice(index, 1)
      }

    }
    this.getFilteredItems()
  }

  getFilteredItems = () => {
    let siteUrl: string = "";

    if (this.online) {
      siteUrl = this.siteurl + this.webpath
    }
    else {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }


    let roleFilter = "";
    for (let x = 1; x <= this.role.length; x++) {
      if (x === this.role.length) {
        roleFilter += "img_role eq '" + this.role[x - 1] + "' "
      }
      else {
        roleFilter += "img_role eq '" + this.role[x - 1] + "' or "
      }
    }

    let groupFilter = "";

    for (let x = 1; x <= this.group.length; x++) {
      if (x === this.group.length) {
        groupFilter += "img_group eq '" + this.group[x - 1] + "' "
      }
      else {
        groupFilter += "img_group eq '" + this.group[x - 1] + "' or "
      }
    }

    let initiativeFilter = "";

    for (let x = 1; x <= this.initiative.length; x++) {
      if (x === this.initiative.length) {
        initiativeFilter += "img_initiative eq '" + this.initiative[x - 1] + "' "
      }
      else {
        initiativeFilter += "img_initiative eq '" + this.initiative[x - 1] + "' or "
      }
    }

    if (roleFilter) {
      roleFilter = "(" + roleFilter + ")"
    }

    if (groupFilter) {
      groupFilter = "(" + groupFilter + ")"
    }
    if (initiativeFilter) {
      initiativeFilter = "(" + initiativeFilter + ")"
    }

    let filter = roleFilter

    if (roleFilter && groupFilter) {
      filter = filter + " and " + groupFilter
    }
    else if (groupFilter) {
      filter = groupFilter
    }
    else {
      filter = roleFilter
    }

    if ((roleFilter || groupFilter) && initiativeFilter) {
      filter = filter + " and " + initiativeFilter
    }
    else if (initiativeFilter) {
      filter = initiativeFilter
    }


    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,img_group,img_initiative,img_organization,img_role,FileLeafRef,img_body,img_readmore&$top=1000&$orderby=Modified desc&$filter=" + filter, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.resultCount = data.d.results.length
        this.isLoading = false;
      });

  }

  getFilters = () => {

    const filterArray = []

    const initFilterArray = []
    const groupFilterArray = []
    const roleFilterArray = []

    this.initiatives.forEach((element, index) => {

      let option = element + index
      let checkid= "id_"+element+index
      initFilterArray.push(
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id={checkid} name={option} value={element} onInput={(event) => this.handleChangeInitiative(event)} />
          <label class="form-check-label" htmlFor={checkid}>{element} </label>
        </div>
      )
    })

    if (this.initiatives.length > 0) {
      filterArray.push(<div class="row"> <div class="col-md-2"> <h5 style={{lineHeight:"2rem"}}>Initiative:</h5> </div><div class="col-md-10">
        {initFilterArray}
      </div>
      </div>)
    }

    this.groups.forEach((element, index) => {

      let option = element + index
      let checkid= "id_"+element+index
      groupFilterArray.push(
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id={checkid} name={option} value={element} onInput={(event) => this.handleChangeGroup(event)} />
          <label class="form-check-label" htmlFor={checkid}>{element} </label>
        </div>
      )
    })
    if (this.groups.length > 0) {
      filterArray.push(<div class="row"> <div class="col-md-2"> <h5 style={{lineHeight:"2rem"}}>Group:</h5> </div><div class="col-md-10">
        {groupFilterArray}
      </div>
      </div>)
    }

  
    this.roles.forEach((element, index) => {

      let option = element + index
      let checkid= "id_"+element+index
      roleFilterArray.push(
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id={checkid} name={option} value={element} onInput={(event) => this.handleChangeRole(event)} />
          <label class="form-check-label" htmlFor={checkid}>{element} </label>
        </div>
      )
    })

    if (this.roles.length > 0) {
       filterArray.push(<div class="row"> <div class="col-md-2"> <h5 style={{lineHeight:"2rem"}}>Role:</h5> </div> <div class="col-md-10">
        {roleFilterArray}
      </div>
      </div> )
    }


    return <div class="filterstyle"> <h5>Filters </h5> <hr></hr>{filterArray}</div>

  }

  getItems = (arr, chunk) => {
    const contentsArray = []
    let columnclass = "col-md-" + Math.trunc(12 / chunk)

    this.roles = _.uniq(_.map(this.origItems, 'img_role'))
    this.groups = _.uniq(_.map(this.origItems, 'img_group'))
    this.initiatives = _.uniq(_.map(this.origItems, 'img_initiative'))



    for (let i = 0; i < arr.length; i += chunk) {

      let tempArray;
      const fragmentsArray = []
      const fragmentsArrayRow = []
      tempArray = arr.slice(i, i + chunk);

      tempArray.forEach((item: any) => {
        let fragment = ""
        let modalComponentId = "#modal" + this.componentid
        let srcUrl = this.webpath + "/" + this.listname + "/" + item.FileLeafRef
        let title = item.FileLeafRef
        if (item.Title) {
          title = item.Title
        }

        fragment =
          <div class="col-md-3" >
            <div class="card">
              <img src={srcUrl} class="mx-auto img-fluid rounded-circle d-block" style={{ maxHeight: "150px" }} />
              <div class="text-center mt-4">
                <h5 class="card-title">{title}</h5>
                <p class="card-text">{item.img_role}</p>
                <p class="card-text">{item.img_group}</p>
                <p class="card-text">{item.img_initiative}</p>
                <p class="card-text">{item.img_organization}</p>


                {item.img_readmore ?
                  <a href={item.img_readmore} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" >Viw More</a>
                  :
                  <a href='#' onClick={(event) => this.handleShow(event, item.img_body, title, srcUrl, item.img_role, item.img_group, item.img_initiative, item.img_organization)} data-bs-toggle="modal" data-bs-target={modalComponentId} id={item.ID} rel="noopener noreferrer" >
                    View More
                  </a>
                }
              </div>
            </div>
          </div>
        fragmentsArray.push(fragment)
      });

      fragmentsArrayRow.push(<div class="row mt-4">{fragmentsArray}</div>)
      contentsArray.push(fragmentsArrayRow)
    }
    if (this.filters)
    {
     return <div>{this.getFilters()} <hr></hr> <p>Showing <span style={{ paddingLeft: "10px" }}></span> {this.resultCount}  <span style={{ paddingLeft: "10px" }}></span> team members <br></br></p>  {contentsArray} </div>
    }
    else{

    return <div> <hr></hr> <p>Showing <span style={{ paddingLeft: "10px" }}></span> {this.resultCount}  <span style={{ paddingLeft: "10px" }}></span> team members <br></br></p>  {contentsArray} </div>
    }

  }

  render() {
    let modalComponentId = "modal" + this.componentid
    let modalVisibilty = "modal"
    if (this.modalShow) {
      modalVisibilty = "modal show"
    }

    return (
      this.isLoading ? <loader-component /> :

        <div>
          {this.getItems(this.items, 4)}
          <div class="container">
            <div class={modalVisibilty} id={modalComponentId} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    {/* <h5 class="modal-title" id="exampleModalLabel">{this.modelTitle}</h5> */}
                    <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={this.handleClose} aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-3 " >
                        <img class="rounded-circle mx-auto d-block img-fluid border-0" src={this.modelImageUrl} />
                      </div>
                      <div class="col-md-9">
                        <h5 class="modal-title" id="exampleModalLabel">{this.modelTitle}</h5>
                        <p class="card-text" > {this.modelRole} </p>
                        <p  class="card-text"> {this.modelGroup} </p>
                        <p class="card-text"> {this.modelInitiative} </p>
                        <p class="card-text" > {this.modelOrganization} </p>
                        {this.modelBody ?
                          <p > <div class="raw-html-style quote" innerHTML={this.modelBody} /> </p>
                          :
                          <p > <div class="raw-html-style" innerHTML={this.modelBody} /> </p>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={this.handleClose}> Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>


    )
  }
}
